import {combineReducers} from 'redux'
import types from '../../actions/types'

export const isVisible = (state = false, action) => {
  switch (action.type) {
    case types.SHOW_POST_CONTACT_LIST_DIALOG:
      return true
    case types.HIDE_POST_CONTACT_LIST_DIALOG:
      return false
    default:
      return state
  }
}

export const isLoading = (state = false, action) => {
  switch (action.type) {
    case types.HUBSPOT_LOAD_LISTS_ATTEMPT:
      return true
    case types.HUBSPOT_LOAD_LISTS_SUCCESS:
      return false
    case types.HUBSPOT_LOAD_LISTS_FAILURE:
      return false
    case types.MAILCHIMP_LOAD_LISTS_ATTEMPT:
      return true
    case types.MAILCHIMP_LOAD_LISTS_SUCCESS:
      return false
    case types.MAILCHIMP_LOAD_LISTS_FAILURE:
      return false
    case types.EMAILING_CONTACT_LIST_POST_ATTEMPT:
      return true
    case types.EMAILING_CONTACT_LIST_POST_SUCCESS:
      return false
    case types.EMAILING_CONTACT_LIST_POST_FAILURE:
      return false
    default:
      return state
  }
}

export const contactList = (state = null, action) => {
  switch (action.type) {
    case types.SHOW_POST_CONTACT_LIST_DIALOG:
      return action.contactList
    case types.HIDE_POST_CONTACT_LIST_DIALOG:
      return null
    default:
      return state
  }
}

export const emailingIntegration = (state = null, action) => {
  switch (action.type) {
    case types.SHOW_POST_CONTACT_LIST_DIALOG:
      return action.emailingIntegration
    case types.HIDE_POST_CONTACT_LIST_DIALOG:
      return null
    default:
      return state
  }
}

export const isContactListPosted = (state = false, action) => {
  switch (action.type) {
    case types.SHOW_POST_CONTACT_LIST_DIALOG:
      return false
    case types.HIDE_POST_CONTACT_LIST_DIALOG:
      return false
    case types.EMAILING_CONTACT_LIST_POST_ATTEMPT:
      return false
    case types.EMAILING_CONTACT_LIST_POST_SUCCESS:
      return true
    case types.EMAILING_CONTACT_LIST_POST_FAILURE:
      return false
    default:
      return state
  }
}

export default combineReducers({
  isVisible,
  isLoading,
  contactList,
  emailingIntegration,
  isContactListPosted,
})
